import Smartphones from 'Salaries/views/SalaryPreviewView/containers/Smartphones'
import Tablets from 'Salaries/views/SalaryPreviewView/containers/Tablets'

import { getCurrentDeviceView } from 'shared/helpers/utils'
import './styles.scss?global'

const SalaryPreviewView = getCurrentDeviceView(Smartphones, Tablets)

export default SalaryPreviewView
